export enum minMaxType {
  duration = 1,
  currency = 2,
  numeric = 3,
  dateTime = 4
}
